import React from 'react';
import PropTypes from 'prop-types';

const AttributeTable = ({ data, headers, keyWidth, preserveKeyFormat, style }) => {
  const styles = {
    component: {
      backgroundColor: '#fff',
      ...style
    },
    table: {
      width: '100%',
      marginTop: 1
    },
    th: {
      border: '0.5px solid rgb(229, 229, 229)',
      padding: 10
    },
    key: {
      textAlign: 'right',
      padding: 10,
      width: keyWidth || 250,
      border: '0.5px solid #e5e5e5',
      background: '#fcfcfc'
    },
    key_content: {
      textAlign: 'right',
      paddingLeft: 20,
      whiteSpace: 'normal',
      lineHeight: '1.4em',
      textTransform: preserveKeyFormat ? 'none' : 'capitalize'
    },
    value: {
      wordBreak: 'break-all',
      padding: 10,
      border: '0.5px solid #e5e5e5',
      lineHeight: '1.4em',
      textAlign: 'left'
    }
  };

  return (
    <div style={styles.component}>
      <table style={styles.table}>
        <thead>
          <tr style={styles.key}>
            {headers &&
              headers.map((header, i) => {
                return (
                  <th key={i} style={{ ...styles.th, textAlign: header.textAlign }}>
                    {header.label}
                  </th>
                );
              })}
          </tr>
        </thead>
        <tbody>
          {Object.keys(data).map(key => {
            return (
              <tr key={key}>
                <td style={styles.key}>
                  <div style={styles.key_content}>
                    {preserveKeyFormat ? key : key.replace(/_/g, ' ')}
                  </div>
                </td>
                <td style={styles.value}>{data[key] === null ? '' : `${data[key]}`}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

AttributeTable.propTypes = {
  data: PropTypes.object,
  headers: PropTypes.array,
  keyWidth: PropTypes.number,
  preserveKeyFormat: PropTypes.bool,
  style: PropTypes.object
};

export default AttributeTable;
